import { useQuery } from '@tanstack/react-query';
import { fetchSecurityGroupsForUser } from '../services/security-groups';

export function useUserSecurityGroupsQuery(userId: string) {
  return useQuery({
    queryKey: ['security', 'users', userId, 'groups'],
    queryFn: () => fetchSecurityGroupsForUser(userId),
    enabled: Boolean(userId),
  });
}
